document.addEventListener("DOMContentLoaded", () => {
    const buttons = document.querySelectorAll(".um-add-cart-btn");

    buttons.forEach(btn => {
        btn.addEventListener("click", async function () {

            let variantId = this.dataset.variantId;

            this.disabled = true;
            this.innerText = "Adding...";

            try {

                const response = await fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        items: [{
                            id: variantId,
                            quantity: 1
                        }]
                    })
                });

                if (!response.ok) {
                    throw new Error("Add to cart failed");
                }

                // refresh drawer content
                await window.umDrawer.refresh();

                // small delay so DOM updates properly
                setTimeout(() => {
                    window.umDrawer.open();
                }, 100);

                this.innerText = "Added ✓";

            } catch (err) {
                console.log(err);
                this.innerText = "Error";
            }

            setTimeout(() => {
                this.disabled = false;
                this.innerText = "Add To Cart";
            }, 1000);

        });
    });
});